import React from 'react'
import PropTypes from 'prop-types'
import {Icon} from '@chakra-ui/react'

const ChevronRight = (props) => {
    return (
        <Icon viewBox="0 0 40 40" {...props}>
            <path
                id="arrow"
                fillRule="evenodd"
                clipRule="evenodd"
                d="M12.9867 5C13.1787 5 13.3707 5.0735 13.5177 5.21899L27.7795 19.4688C27.9205 19.6098 28 19.8003 28 19.9998C28 20.1993 27.9205 20.3898 27.7795 20.5308L13.5177 34.7806C13.2237 35.0731 12.7497 35.0731 12.4557 34.7806C12.1632 34.4866 12.1632 34.0126 12.4557 33.7186L26.1895 19.9998L12.4557 6.28098C12.1632 5.98699 12.1632 5.51299 12.4557 5.21899C12.6027 5.0735 12.7947 5 12.9867 5Z"
                fill="currentColor"
            />
        </Icon>
    )
}

ChevronRight.propTypes = {onClick: PropTypes.func}

export default ChevronRight
